import {ControlledFormField} from '@hconnect/common/types'
import {Controller, FieldValues} from 'react-hook-form'

import {AttachmentsDropzone} from './AttachmentsDropzone'

type Props<TField extends FieldValues> = Omit<ControlledFormField<TField>, 'label'> & {
  onChange?: (value: File[]) => void
  translationPrefix?: string
  files?: File[]
}

export const AttachmentsField = <TField extends FieldValues>(props: Props<TField>) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({field, fieldState}) => (
        <AttachmentsDropzone
          value={field.value ?? []}
          onChange={(files) => {
            field.onChange(files)
          }}
          hint={fieldState.error?.message}
        />
      )}
    />
  )
}
